module.exports = __webpack_public_path__ + "media/images/voice04-2-9225790096645568b5c4d0ce0da40136.jpg";